import openSocket from "socket.io-client";
const socketEndpoint =
  process.env.REACT_APP_SOCKET_ENDPOINT || "http://localhost:5000";
const socket = openSocket(socketEndpoint);

socket.on("connect", () => {});
